import { render, staticRenderFns } from "./LoginLinks.vue?vue&type=template&id=56a1a1ca&scoped=true"
import script from "./LoginLinks.vue?vue&type=script&lang=js"
export * from "./LoginLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1a1ca",
  null
  
)

export default component.exports